import type {CloseButtonProps} from '@chakra-ui/react';
import {useAlertStyles} from '@chakra-ui/react';
import {ChakraDiv} from '@linx-security/ui/utils/chakra-elements';
import type {FC} from 'react';

import {parts} from './theme/anatomy';

export const AlertActions: FC<CloseButtonProps> = props => {
  const {actions} = useAlertStyles();
  return <ChakraDiv sx={actions} {...props} {...parts.actions.attrs} />;
};
